import { render, staticRenderFns } from "./status-form-step.vue?vue&type=template&id=e84c5a80&scoped=true&"
import script from "./status-form-step.vue?vue&type=script&lang=js&"
export * from "./status-form-step.vue?vue&type=script&lang=js&"
import style0 from "./status-form-step.vue?vue&type=style&index=0&id=e84c5a80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84c5a80",
  null
  
)

export default component.exports